module.exports = __webpack_public_path__ + "static/img/about_img.bd95073.png";